<div class="pid-table-wrap">

  <div *ngIf="putToken">putToken: {{putToken}}<br />putUrl: {{putUrl}}<br /><button (click)="completeTransferPDF()">Complete</button></div>

  <div style="margin-bottom:60px;overflow: hidden;margin-top: 20px;">
    <div class="tablefilters">
      <div class="title">{{translate.instant('DATA.STATUS')}}</div>
      <div class="filter" *ngFor="let status of allStatusTypes;let last = last">
        <a class="filter" [ngClass]="statusSelected(status, last)" *ngIf="status && status != 'template' "
          id="id_filter_status_{{status}}" (click)="updateFilter($event)">
          <img alt="{{status}}" class="logo" src="{{status2imgfn(status)}}" />
          <span class="col2">{{translate.instant('PID.STATUS.' + status)}} ({{allStatusCount[status]}}) </span>
        </a>
      </div>
      <br />

      <div class="title">{{translate.instant('DATA.LEAD')}}</div>
      <div class="filter" *ngFor="let owner of allPIDOwnerTypes;let last = last">
        <a class="filter" [ngClass]="ownerSelected(owner)" *ngIf="owner && owner.name" id="id_filter_owner_{{owner.id}}"
          (click)="updateFilter($event)">
          <span class="logo">{{owner.name.slice(0,1)}}</span>
          <span class="col2">{{owner.name}}</span>
        </a>
      </div>
      <br />
    </div>

    <div class="datatable-wrap">
      <ngx-datatable class="bootstrap" *ngIf="!isPhone" [rows]="pids.filtered" [rowHeight]="170" [headerHeight]="50">

        <ngx-datatable-column name="{{translate.instant('DATA.STATUS')}}" [width]="getWidth('status')" [sortable]="true"
          prop="status" [comparator]="statusComparator">

          <ng-template let-row="row" ngx-datatable-cell-template>
            <div (click)="details(row)">
              <img alt="{{row.status}}" class="logo" src="{{status2imgfn(row.status)}}" class="pid-status-img" />
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{translate.instant('DATA.NAME')}}" [width]="180" [sortable]="true" prop="name"
          [comparator]="comparator">

          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="divider2 left-divider2" (click)="details(row)">
              <div class="content">
                <div class="title"><b>{{row.name}}</b></div>
                <br />

                <div>
                  <img alt="{{translate.instant('PID.TYPE.' + row.type)}}" class="logo" src="{{type2imgfn(row.type)}}"
                    style="height:22px;top:130px;position:absolute" />
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{translate.instant('DATA.DESCRIPTION')}}" [width]="200" [sortable]="true"
          prop="shortDescription" [comparator]="comparator">

          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="divider2" (click)="details(row)">
              <div class="content">
                <div><b>{{row.shortDescription}}</b></div>
                <br />
                <div style="position: absolute; bottom:12px;">
                  {{row.address.address}}<br />
                  {{row.address.zip}} {{row.address.city}}
                  <span *ngIf="row.address.country">, </span>{{row.address.country}}
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{translate.instant('DATA.OWNER')}}" [width]="200" [sortable]="true"
          prop="PIDOwner.email" [comparator]="comparator">

          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="divider2" (click)="details(row)">

              <div class="content" style="height: 100%;position: relative">

                <!----                   OWNER                      -->
                <div *ngIf="row.owner && row.status != 'transferred' "><i><b>{{translate.instant('DATA.OWNER')}}:
                    </b>&nbsp; <span *ngIf="row.owner.firstname">{{row.owner.firstname}}
                      {{row.owner.lastname}}</span><span *ngIf="!row.owner.firstname">{{row.owner.name}}</span></i>
                </div>

                <div *ngIf="!row.owner && row.status != 'transferred'"><i><b>{{translate.instant('DATA.OWNER')}}:
                    </b>&nbsp; {{translate.instant('DATA.NO_OWNER')}}</i></div>
                <i><b>{{translate.instant('DATA.LEAD')}}: </b>&nbsp; {{row.PIDOwner.firstname}}
                  {{row.PIDOwner.lastname}}</i><br />

                <!----                   STATUS                      -->
                <div style="position: absolute; bottom:12px;"
                  *ngIf="!row.copy && !row.template && row.status == 'open' && !(row.sharedWith && row.sharedWith.length)">
                  {{translate.instant('PID_CARD.NOT_SHARED_TRANSFERRED')}}</div>

                <div *ngIf="row.status == 'transferred'" class="transferred" style="position: absolute; bottom:12px;">
                  {{translate.instant('PID_CARD.TRANSFERRED_TO')}}
                  <span *ngIf="row.transferTo.details.length">{{transferInfo(row)}}</span> <span
                    *ngIf="row.transferTo.completedAt">{{translate.instant('PID_CARD.AT_DATE')}}
                    {{row.transferTo.completedAt | date: 'dd/MM/yyyy'}}</span>

                </div>
                <div *ngIf="!row.template && row.status == 'pending'" class="transferred"
                  style="position: absolute; bottom:12px;">
                  {{translate.instant('PID_CARD.TRANSFER_PENDING')}}
                  <span *ngIf="row.transferTo.details.length">{{transferInfo(row)}}</span>
                </div>
                <div *ngIf="row.copy && row.template" class="transferred" style="position: absolute; bottom:12px;">
                  {{translate.instant('PID_CARD.TEMPLATE')}}</div>

                <div *ngIf="!row.copy && !row.template && row.sharedWith && row.sharedWith.length && sharedWithMe(row)"
                  style="position: absolute; bottom:12px;" class="transferred">
                  {{translate.instant('DATA.SHARED_WITH_ME')}}
                </div>

                <div *ngIf="!row.copy && !row.template && row.sharedWith && row.sharedWith.length && !sharedWithMe(row)"
                  style="position: absolute; bottom:12px;" class="transferred">{{translate.instant('PID_CARD.SHARED')}}
                  {{sharedInfo(row)}}
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{translate.instant('DATA.COMPLETION')}}" [width]="getWidth('completion')"
          [sortable]="true" prop="percentage">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="divider2" (click)="details(row)">
              <div class="content" style="padding-left:6px; padding-right:6px;">
                <div>
                  <p style="margin-top:50px;position:relative">
                    <span class="pad-hide"
                      style="position:absolute; bottom:17px">{{translate.instant('PID_CARD.PID')}}</span>
                    <span *ngIf="row.fileTotal"> {{row.fileCompleted}} /
                      {{row.fileTotal}}</span>

                    <span class="pidicon" [ngClass]="{first: 'row.late'}" *ngIf="row.late"><img alt="late"
                        class="status-icon" src="../../assets/Nestas_status_late.png" /></span>
                    <span class="pidicon" *ngIf="row.warning"><img alt="warning" class="status-icon"
                        src="../../assets/Nestas_status_warning.png" /></span>
                  </p>
                  <div>
                    <mat-progress-bar mode="determinate" [value]="row.percentage"
                      [class.progress-bar-attention]="row.percentage < 40"
                      [class.progress-bar-warning]="row.percentage >= 40 && row.percentage < 70"></mat-progress-bar>
                  </div>
                  <div class="units" *ngIf="row.children && row.children.length">{{row.children.length}}
                    {{translate.instant('PID.UNITS')}}</div>
                </div>

              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="documents" [width]="140" [sortable]="false">
          <ng-template let-column="column" ngx-datatable-header-template><span style="margin-left:20px">&nbsp;</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="divider2">
              <div class="content" style="padding-left:0px;padding-right:0">
                <div style="padding-top:50px;padding-bottom:10px" class="overlay" (click)="details(row)">
                  <a *ngIf="userIsAllowed(row) && (row.template || 1)"
                    (click)="modal.pid = row; modal.newPID = true; $event.stopPropagation();"
                    style="margin-right:5px;margin-left:5px" class="img"
                    title="{{translate.instant('BUTTON.ACTION.COPY')}}"><img alt="duplicate"
                      src="../../assets/Nestas_toolbox_dupliceren.png" />
                  </a>

                  <!--&& !row.copy-->
                  <a *ngIf="userIsAllowed(row)" 
                    (click)="modal.pid = row; modal.editPID = true; $event.stopPropagation();" style="margin-right:5px"
                    class="img" title="{{translate.instant('BUTTON.ACTION.EDIT')}}"><img alt="edit"
                      src="../../assets/Nestas_toolbox_bewerken.png" />
                  </a>

                  <!-- && allowTransfer(row)-->
                  <a *ngIf="userIsAllowed(row) && canEditTransferInfo(row)"
                    (click)="modal.pid = row; modal.transferPID = true; $event.stopPropagation();" class="img"
                    title="{{translate.instant('BUTTON.ACTION.TRANSFER')}}"><img alt="share"
                      src="../../assets/Nestas_toolbox_delen_narrow.png" />
                  </a>

                </div>
                <div style="margin-top:10px;margin-left:17px">
                  <a (click)="details(row)"
                    style="margin-left:2px;border: 1px solid #d1d4d7;border-radius: 10px;text-transform: uppercase;">{{translate.instant('DATA.DOCUMENTEN')}}
                  </a>
                </div>

              </div>
            </div>
          </ng-template>

        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </div>

  <mat-checkbox *ngIf="tableCount > 100 && pids.filtered.length != tableCount" (change)="showAllToggle()"
    [(ngModel)]="showAll">Show All</mat-checkbox>


  <!-- Edit PID -->
  <fsmodal *ngIf="editable" [show]="modal.editPID" [closable]=true (closed)="modal.editPID = false;"
    class="edit-pid-component">
    <!--<div class="modal-title-content">{{translate.instant('MODAL.TITLE.EDIT_PID')}}</div>-->

    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>
      <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="modal.pid"></nestas-pidinfo>

      <div class="wrap">
        <new-pid #modalEditPID *ngIf="modal.editPID" [newPID]="modal.pid" [parentPID]="modal.pid.parentPID" [pids]="[]"
          (cancelled)="modal.editPID = false;"></new-pid>

        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-stroked-button
            (click)="modal.editPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>

          <button *ngIf="!(modal.pid && modal.pid.copy)" mat-raised-button (click)="modalEditPID.addPID()" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>
        </div>
      </div>

    </div>

  </fsmodal>



  <!-- Copy PID -->
  <fsmodal [show]="modal.newPID" [closable]=true (closed)="modal.newPID = false;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.COPY_PID')}}</div>
    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>
      <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="modal.pid"></nestas-pidinfo>

      <div class="wrap">
        <new-pid #modalCopyPID *ngIf="modal.newPID" [copyOf]="modal.pid" [parentPID]="modal.pid.parentPID"
          [pids]="pids.all" (cancelled)="modal.newPID = false;"></new-pid> <!-- (done)="reload()"-->
        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-stroked-button
            (click)="modal.newPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
          <button mat-raised-button (click)="modalCopyPID.addPID(this.updateall);" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>
        </div>
      </div>
    </div>
  </fsmodal>

  <pid-transfer-modal *ngIf="editable" [show]="modal.transferPID" [pids]="pids" [steps]="steps" [modal]="modal"
    [doUpdateFilter]="reloadHome"></pid-transfer-modal>